import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { string as yupString } from "yup";
import TextInputField from "./text-input-field";
import sharedMessages from "../../../../shared-messages";

const GivenNameField = ({ isRequired = true }) => {
  const { formatMessage } = useIntl();

  let labelMessage = sharedMessages.firstName;
  let givenNameValidationSchema = yupString().required(
    formatMessage(sharedMessages.requireFirstName)
  );

  if (!isRequired) {
    labelMessage = sharedMessages.firstNameOptional;
    givenNameValidationSchema = null;
  }

  return (
    <TextInputField
      id="given-name"
      className="given-name"
      name="givenName"
      label={formatMessage(labelMessage)}
      validationSchema={givenNameValidationSchema}
      aria-required={isRequired.toString()}
      autocomplete="given-name"
    />
  );
};

GivenNameField.propTypes = {
  isRequired: PropTypes.bool
};

export default GivenNameField;
